import * as tslib_1 from "tslib";
import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';
import { deviationSchema, deviationExtendedSchema, } from '../normalizr/schemas/deviation';
import { getDataEntities, getDataEntityById } from '../entities';
import { getUserById } from '../users/selectors';
import { getCurrentUserId } from '../../publicSession/selectors';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import DeviationMediaService from '../../utils/DeviationMediaService';
export var getNormalizedDeviationById = function (state, entityId) {
    return getDataEntityById(state, deviationSchema, entityId);
};
var getDeviationAuthorByDeviationId = function (state, entityId) {
    var deviation = getNormalizedDeviationById(state, entityId);
    if (!deviation) {
        return;
    }
    return getUserById(state, deviation.author);
};
export var getDeviationById = createSelector([getNormalizedDeviationById, getDeviationAuthorByDeviationId], function (deviation, author) {
    if (!deviation) {
        return undefined;
    }
    return tslib_1.__assign({}, deviation, { author: author, extended: undefined });
});
export var getExtendedDeviationById = createSelector([function (state, entityId) { return entityId; }, getDeviationById, getDataEntities], function (entityId, deviation, entities) {
    if (!deviation || !entities[deviationExtendedSchema.key]) {
        return deviation;
    }
    // extended has a ton of stuff inside, needs to be denormalized
    deviation.extended = denormalize(entityId, deviationExtendedSchema, entities);
    return deviation;
});
export var getDeviationsByIds = function (state, ids) {
    return ids.map(function (id) { return getDeviationById(state, id); });
};
export var getIsGif = function (deviation) {
    return DeviationMediaService.isGif(deviation);
};
export function getIsCurrentUserAuthorOf(state, deviation) {
    var currentUserId = getCurrentUserId(state);
    if (!currentUserId || !deviation.author) {
        return false;
    }
    return deviation.author.userId === currentUserId;
}
export function getDeviationEditUrl(_a) {
    var extended = _a.extended, deviation = tslib_1.__rest(_a, ["extended"]);
    var deviationType = getDeviationType(deviation);
    // some types never go to edit page
    if ([
        DeviationTypes.COMMISSION,
        DeviationTypes.STATUS,
        DeviationTypes.POLL,
    ].includes(deviationType)) {
        return;
    }
    if (deviation.legacyTextEditUrl) {
        return deviation.legacyTextEditUrl;
    }
    // non-legacy journals/lit don't go to edit page
    if (![DeviationTypes.JOURNAL, DeviationTypes.LITERATURE].includes(deviationType)) {
        return extended && extended.editUrl;
    }
}
export function getDeviationIdFromNormalizedId(state, normalizedId) {
    var deviation = getNormalizedDeviationById(state, normalizedId);
    return (deviation && deviation.deviationId) || normalizedId;
}
//# sourceMappingURL=selectors.js.map